import React, { useState } from "react";
import { Box, Table, TableRow, TableHead, TableBody, TableCell, Typography, Checkbox } from "@mui/material";
import { useUpdatePool } from "../../../hooks/pools/useUpdatePool";
import { useCFBSurvivorContext } from "../context/CFBSurvivorContext";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import useNavigateToTop from "../../../hooks/general/useNavigateToTop";

//const PoolRankingsTable = ({ myUserId, gameId, userSubgroups, partyState, setPartyState, partyId, setPartyId, setDefaultPartyId, setDefaultPartyName } ) => {
const CFBSurvivorPoolRankingsTable = () => {
    const { mutate } = useUpdatePool();
    const { myUserId, gameAddress, mainGameId, userSubgroups, partyState, setPartyState, partyId, setPartyId, setDefaultPartyId, setDefaultPartyName, userPicksFromDB } = useCFBSurvivorContext();
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    //console.log("User Subgroups:", userSubgroups);

    const navigateToTop = useNavigateToTop();

    const uriEncoded = (link) => {
        return encodeURI(`${encodeURIComponent(link)}`);
      }

    const handleGameClick = (id, name) => {
        //console.log("Game Clicked:", id, name);
        setPartyState(name);
        setPartyId(id);
        navigateToTop(`/${uriEncoded(gameAddress)}/${uriEncoded(mainGameId)}/${uriEncoded("LEADERBOARD")}/${uriEncoded(id)}`);
    }
        

    const handleDefaultPartyChange = async (updateValue, updateName) => {
        if (updateValue === partyId) {
            return;
        }

        let picksData = {
            updateKey: "defaultParty",
            updateValue: updateValue,
            userID: myUserId,
            gameId: mainGameId,
        };
        //console.log("Picks Data:", picksData);
            
        try {
            await mutate(picksData, {
                onSuccess: async () => {
                    try {
                        //console.log("Picks submitted successfully");
                        setPartyState(updateName);
                        setPartyId(updateValue);
                        setDefaultPartyId(updateValue);
                        setDefaultPartyName(updateName);
                    } catch (error) {
                        console.error("An error occurred while fetching user data:", error);
                    }
                },
                onError: (error) => {
                    console.error("An error occurred while submitting the scorecard:", error);
                },
            });
        } catch (error) {
            console.error("An error occurred while submitting the scorecard:", error);
        }
    }

    const isUserEliminated = userPicksFromDB?.filter(pick => pick.result === "Loss").length === 4;
    const howManyLosses = userPicksFromDB?.filter(pick => pick.result === "Loss").length;
    //console.log("Is User Eliminated:", isUserEliminated, "How Many Losses:", howManyLosses, userPicksFromDB);

    return (
        <Box
            sx={{
                display: 'flex',
                padding: '16px 32px 0 32px',
                flexDirection: 'column',
                alignSelf: 'stretch',
                alignContent: 'center',
                justifyContent: 'center',
                maxWidth: '500px',
                margin: '0 auto',
                marginTop: '32px',
            }}
        >
            <Typography
                style={{
                    color: '#002129',
                    textAlign: 'center',
                    fontSize: isMobile ? '16px' : '24px',
                    fontWeight: 700,
                    textDecorationLine: 'underline',
                }}
            >
                My Party
            </Typography>
            <Box
                sx={{
                    marginTop: '8px',
                }}
            >
                <Typography
                    sx={{
                        fontWeight: '700',
                    }}
                >
                My Status: 
                    <span style={{ marginLeft: '4px', color: isUserEliminated ? '#CC293C' : '#00AA72' }}>
                        {isUserEliminated ? 'ELIMINATED' : `ALIVE (${4 - howManyLosses}/4)`}
                    </span>
                </Typography>
            </Box>
            <Box>
                <Table sx={{ tableLayout: 'fixed', width: '100%', border: 'none' }}>
                    <TableHead>
                        <TableRow sx={{ borderBottom: 'none' }}>
                            <TableCell style={{ width: '142px', borderBottom: 'none' }}>
                                <Typography
                                    style={{
                                        color: '#002129',
                                        fontSize: '14px',
                                        fontWeight: '700',
                                        textDecorationLine: 'underline'
                                    }}
                                >
                                    Party
                                </Typography>
                            </TableCell>
                            {/* <TableCell style={{ width: '83px', textAlign: 'center', borderBottom: 'none' }}>
                                <Typography
                                    style={{
                                        color: '#002129',
                                        fontSize: '14px',
                                        fontWeight: '700',
                                        textDecorationLine: 'underline'
                                    }}
                                >
                                    Rank
                                </Typography>
                            </TableCell> */}
                            <TableCell style={{ width: '108px', textAlign: 'center', borderBottom: 'none' }}>
                                <Typography
                                    style={{
                                        color: '#002129',
                                        fontSize: '14px',
                                        fontWeight: '700',
                                        textDecorationLine: 'underline',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Default Pool
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* First static row */}
                        <TableRow sx={{ borderBottom: 'none' }}>
                            <TableCell style={{ width: '142px', padding: '0px', borderBottom: 'none' }}>
                                <Typography
                                    style={{
                                        color: '#002129',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        textDecoration: 'underline',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleGameClick(mainGameId, "Pool Party")}
                                >
                                    Pool Party Main Event
                                </Typography>
                            </TableCell>
                            {/* <TableCell style={{ width: '83px', padding: '0px', textAlign: 'center', borderBottom: 'none' }}>
                                <Typography
                                    style={{
                                        color: '#002129',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    T-5
                                </Typography>
                                <Typography
                                    style={{
                                        color: '#002129',
                                        fontSize: '8px',
                                        fontWeight: '700',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Out of 345
                                </Typography>
                            </TableCell> */}
                            <TableCell style={{ width: '108px', padding: '0px', textAlign: 'center', borderBottom: 'none' }}>
                                <Checkbox
                                    checked={partyId === mainGameId}
                                    sx={{
                                        width: '24px',
                                        height: '24px',
                                        padding: 0
                                    }}
                                    onChange={() => handleDefaultPartyChange(mainGameId, "Pool Party")}
                                />
                            </TableCell>
                        </TableRow>

                        {/* Dynamically created rows */}
                        {userSubgroups?.map((subgroup, index) => {
                            //console.log(`Checking partyId: ${partyId} against subgroup.subGroupID: ${subgroup.subGroupID}`);
                            return (
                                <TableRow key={index} sx={{ borderBottom: 'none' }}>
                                    <TableCell style={{ width: '142px', padding: '0px', borderBottom: 'none' }}>
                                        <Typography
                                            style={{
                                                color: '#002129',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                textDecoration: 'underline',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => handleGameClick(subgroup.subGroupID, subgroup.name)}
                                        >
                                            {subgroup.name}
                                        </Typography>
                                    </TableCell>
                                    <TableCell style={{ width: '108px', padding: '0px', textAlign: 'center', borderBottom: 'none' }}>
                                        <Checkbox
                                            checked={partyId === subgroup.subGroupID}
                                            sx={{
                                                width: '24px',
                                                height: '24px',
                                                padding: 0
                                            }}
                                            onChange={() => handleDefaultPartyChange(subgroup.subGroupID, subgroup.name)}
                                        />
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </Box>
        </Box>
    );
}

export default CFBSurvivorPoolRankingsTable;
